// import jobApi from '../../api/JobApi';
import AuthApi from '../../services/api/AuthApi';
import { authActions } from '../slices/authSlice';
import { parseJwt } from '../../utils/jwt';
import UserApi from '../../services/api/UserApi';
import ClientApi from '../../services/api/ClientApi';
// import dummyResponseDataForPetroHubUser from '../../pages/administrator/user/constants/dummyData';

const calculateRemainingTime = (expirationTime) => {
  const currentTime = new Date().getTime();
  const adjExpirationTime = new Date(expirationTime).getTime();
  const remainingDuration = adjExpirationTime - currentTime;
  return remainingDuration || 0;
};

const retrieveStoredToken = () => {
  const storedToken = localStorage.getItem('accessToken');
  const storedExpirationDate = localStorage.getItem('expirationTime');

  const remainingTime = calculateRemainingTime(+storedExpirationDate);

  if (remainingTime <= 10000) {
    // 10 s
    localStorage.removeItem('token');
    localStorage.removeItem('expirationTime');
    return null;
  }

  return {
    token: storedToken,
    duration: remainingTime,
  };
};

const getUserDateTimeFormats = (user) => {
  if (user) {
    return {
      dateFormat: user.DateFormat || 'MM/dd/yyyy',
      dateTimeFormat: user.DateTimeFormat || 'MM/dd/yyyy',
    };
  }
  return {
    dateFormat: 'MM/dd/yyyy',
    dateTimeFormat: 'MM/dd/yyyy',
  };
};

export const initialize = () => async (dispatch) => {
  try {
    const tokenData = retrieveStoredToken();

    if (tokenData && tokenData.token) {
      dispatch(authActions.updateValidatingToken(true));
      const loginUserData = await AuthApi.me(tokenData.token);
      const { dateFormat, dateTimeFormat } = getUserDateTimeFormats(
        loginUserData.User
      );

      let isClientOnHold = false;
      if (loginUserData) {
        const { IsAllOnhold, NormalClientIDs, OnHoldClientIDs } = await ClientApi.checkUserOnHold();
        if (Array.isArray(OnHoldClientIDs) && OnHoldClientIDs.length > 0) {
          // Regenerate a new JWT Token
          const adjustedToken = await AuthApi.adjustToken({
            token: tokenData.token,
            claims: [{
              ClaimType: 'Res#AssignedClients',
              ClaimValue: JSON.stringify(NormalClientIDs)
            }],
          });

          localStorage.setItem('accessToken', adjustedToken.accessToken);
          const { exp } = parseJwt(adjustedToken.accessToken);
          localStorage.setItem('expirationTime', exp * 1000);
        }

        if (Array.isArray(NormalClientIDs) && NormalClientIDs.length > 0) {
          const assignedClientObject = loginUserData.UserObjects.find((x) => x.ObjectType === 'AssignedClients');
          if (assignedClientObject) {
            assignedClientObject.ObjectData = JSON.stringify(NormalClientIDs);
          }
        }

        isClientOnHold = IsAllOnhold;
      }
      dispatch(
        authActions.updateLoginUser({
          isAuthenticated: true,
          user: loginUserData.User,
          roleClaims: loginUserData.RoleClaims,
          token: tokenData.token,
          userObjects: loginUserData.UserObjects,
          dateFormat,
          dateTimeFormat,
          permissions: loginUserData.Permissions,
          userToRoles: loginUserData.UserToRoles,
          isPetroHubUser: false,
          isClientOnHold
        })
      );
      dispatch(authActions.updateValidatingToken(false));
    } else {
      dispatch(
        authActions.updateLoginUser({
          isAuthenticated: false,
          user: null,
          roleClaims: null,
          permissions: null,
          userToRoles: null,
          userObjects: null,
          isPetroHubUser: false,
        })
      );
    }
  } catch (err) {
    dispatch(
      authActions.updateLoginUser({
        isAuthenticated: false,
        user: null,
        roleClaims: null,
        permissions: null,
        userToRoles: null,
        userObjects: null,
        isPetroHubUser: false,
      })
    );

    dispatch(authActions.updateValidatingToken(false));
  }
};

export const initializePetroHub = () => async (dispatch) => {
  try {
    const tokenData = retrieveStoredToken();

    if (tokenData && tokenData.token) {
      dispatch(authActions.updateValidatingToken(true));
      const loginUserData = await AuthApi.mePetroHub(tokenData.token);
      const { dateFormat, dateTimeFormat } = getUserDateTimeFormats(
        loginUserData.User
      );
      let isClientOnHold = false;
      if (loginUserData) {
        const { IsAllOnhold, NormalClientIDs, OnHoldClientIDs } = await ClientApi.checkUserOnHold();
        if (Array.isArray(OnHoldClientIDs) && OnHoldClientIDs.length > 0) {
          // Regenerate a new JWT Token
          const adjustedToken = await AuthApi.adjustToken({
            token: tokenData.token,
            claims: [{
              ClaimType: 'Res#AssignedClients',
              ClaimValue: JSON.stringify(NormalClientIDs)
            }],
          });

          localStorage.setItem('accessToken', adjustedToken.accessToken);
          const { exp } = parseJwt(adjustedToken.accessToken);
          localStorage.setItem('expirationTime', exp * 1000);
        }

        if (Array.isArray(NormalClientIDs) && NormalClientIDs.length > 0) {
          const assignedClientObject = loginUserData.UserObjects.find((x) => x.ObjectType === 'AssignedClients');
          if (assignedClientObject) {
            assignedClientObject.ObjectData = JSON.stringify(NormalClientIDs);
          }
        }

        isClientOnHold = IsAllOnhold;
      }
      const userGlobalFilterPetroHub = window.localStorage.getItem('userGlobalFilterPetroHub');
      // const { Contacts, Addresses } = await UserApi.getUserByUserIdPetroHub(loginUserData.User?.UserID); // need to make a separate API call to get contact and address details as these details are not coming in response of user details API for petrohub, but these details are required in application. For non-petrohub user, these details are coming in response of user details API.
      // const { Contacts = dummyResponseDataForPetroHubUser.Contacts } = dummyResponseDataForPetroHubUser; // for petrohub, as contacts are not coming in response, using dummy contacts data for now. Will remove it once we get contacts data from API response.
      // const { Addresses = dummyResponseDataForPetroHubUser.Addresses } = dummyResponseDataForPetroHubUser; // for petrohub, as addresses are not coming in response, using dummy addresses data for now. Will remove it once we get addresses data from API response.
      dispatch(
        authActions.updateLoginUser({
          isAuthenticated: true,
          user: loginUserData.User,
          roleClaims: loginUserData.RoleClaims,
          token: tokenData.token,
          userObjects: loginUserData.UserObjects,
          dateFormat,
          dateTimeFormat,
          isClientOnHold,
          permissions: loginUserData.Permissions,
          userToRoles: loginUserData.UserToRoles,
          isPetroHubUser: true,
          // userContactList: Contacts,
          // userAddressList: Addresses,
          userGlobalFilterPetroHub: userGlobalFilterPetroHub ? JSON.parse(userGlobalFilterPetroHub) : null,
        })
      );
      dispatch(authActions.updateValidatingToken(false));
    } else {
      dispatch(
        authActions.updateLoginUser({
          isAuthenticated: false,
          user: null,
          roleClaims: null,
          permissions: null,
          userToRoles: null,
          userObjects: null,
          // userContactList: null,
          // userAddressList: null,
          userGlobalFilterPetroHub: null,
          isPetroHubUser: false,
        })
      );
    }
  } catch (err) {
    dispatch(
      authActions.updateLoginUser({
        isAuthenticated: false,
        user: null,
        roleClaims: null,
        permissions: null,
        userToRoles: null,
        userObjects: null,
        // userContactList: null,
        // userAddressList: null,
        userGlobalFilterPetroHub: null,
        isPetroHubUser: false,
      })
    );

    dispatch(authActions.updateValidatingToken(false));
  }
};

export const login = (data) => async (dispatch) => {
  const { username, password } = data;
  const { accessToken, userData } = await AuthApi.login({
    username,
    password,
  });

  const { exp } = parseJwt(accessToken);

  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('expirationTime', exp * 1000);

  let finalJwtToken = accessToken;
  let isClientOnHold = false;
  if (accessToken) {
    const { IsAllOnhold, NormalClientIDs, OnHoldClientIDs } = await ClientApi.checkUserOnHold();

    if (!IsAllOnhold) {
      if (Array.isArray(OnHoldClientIDs) && OnHoldClientIDs.length > 0) {
        const assignedClientObject = userData.UserObjects.find((x) => x.ObjectType === 'AssignedClients');
        if (assignedClientObject) {
          assignedClientObject.ObjectData = JSON.stringify(NormalClientIDs);
        }

        // Regenerate a new JWT Token
        const adjustedToken = await AuthApi.adjustToken({
          token: accessToken,
          claims: [{
            ClaimType: 'Res#AssignedClients',
            ClaimValue: JSON.stringify(NormalClientIDs)
          }],
        });

        finalJwtToken = adjustedToken.accessToken;
        localStorage.setItem('accessToken', finalJwtToken);
      }
    }

    isClientOnHold = IsAllOnhold;
  }

  const { dateFormat, dateTimeFormat } = getUserDateTimeFormats(userData.User);

  dispatch(
    authActions.updateLoginUser({
      isAuthenticated: true,
      user: userData.User,
      roleClaims: userData.RoleClaims,
      token: finalJwtToken,
      userObjects: userData.UserObjects,
      dateFormat,
      dateTimeFormat,
      isPetroHubUser: false,
      isClientOnHold
    })
  );
};

export const loginPetroHub = (data) => async (dispatch) => {
  const { username, password } = data;
  const { accessToken } = await AuthApi.loginPetroHub({
    username,
    password,
  });

  const { exp } = parseJwt(accessToken);

  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('expirationTime', exp * 1000);

  let finalJwtToken = accessToken;
  const { User, Permissions, UserObjects, RoleClaims, UserToRoles } = await AuthApi.mePetroHub(finalJwtToken);

  let isClientOnHold = false;
  if (!accessToken) {
    const { IsAllOnhold, NormalClientIDs, OnHoldClientIDs } = await ClientApi.checkUserOnHold();

    if (!IsAllOnhold) {
      if (Array.isArray(OnHoldClientIDs) && OnHoldClientIDs.length > 0) {
        const assignedClientObject = UserObjects.find((x) => x.ObjectType === 'AssignedClients');
        if (assignedClientObject) {
          assignedClientObject.ObjectData = JSON.stringify(NormalClientIDs);
        }

        // Regenerate a new JWT Token
        const adjustedToken = await AuthApi.adjustToken({
          token: accessToken,
          claims: [{
            ClaimType: 'Res#AssignedClients',
            ClaimValue: JSON.stringify(NormalClientIDs)
          }],
        });

        finalJwtToken = adjustedToken.accessToken;
        localStorage.setItem('accessToken', finalJwtToken);
      }
    }

    isClientOnHold = IsAllOnhold;
  }

  const { dateFormat, dateTimeFormat } = getUserDateTimeFormats(User);
  // need to make a separate API call to get contact and address details as these details are not coming in response of user details API for petrohub, but these details are required in application. For non-petrohub user, these details are coming in response of user details API.
  // const { Contacts, Addresses } = await UserApi.getUserByUserIdPetroHub(User?.UserID);
  const userGlobalFilterPetroHub = window.localStorage.getItem('userGlobalFilterPetroHub');
  // const { Contacts = dummyResponseDataForPetroHubUser.Contacts } = dummyResponseDataForPetroHubUser; // for petrohub, as contacts are not coming in response, using dummy contacts data for now. Will remove it once we get contacts data from API response.
  // const { Addresses = dummyResponseDataForPetroHubUser.Addresses } = dummyResponseDataForPetroHubUser; // for petrohub, as addresses are not coming in response, using dummy addresses data for now. Will remove it once we get addresses data from API response.

  // console.log('Contacts', Contacts);
  // console.log('Addresses', Addresses);

  dispatch(
    authActions.updateLoginUser({
      isAuthenticated: true,
      user: User,
      roleClaims: RoleClaims,
      token: finalJwtToken,
      userObjects: UserObjects,
      dateFormat,
      dateTimeFormat,
      isClientOnHold,
      permissions: Permissions,
      userToRoles: UserToRoles,
      // userContactList: Contacts,
      // userAddressList: Addresses,
      isPetroHubUser: true,
      userGlobalFilterPetroHub: userGlobalFilterPetroHub ? JSON.parse(userGlobalFilterPetroHub) : null,
    })
  );
};

export const logout = () => async (dispatch) => {
  try {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('expirationTime');
    localStorage.removeItem('userGlobalFilterPetroHub');

    dispatch(authActions.logout());
    dispatch({ type: 'store/reset' });
  } catch (err) {
    console.log(err);
  }
};

export const startImpersonating = (data) => async (dispatch) => {
  const { UserAccountID, UserID, Username } = data;
  const userData = await UserApi.getUserDataWithRoleByUserID({
    userId: UserID,
  });
  const { dateFormat, dateTimeFormat } = getUserDateTimeFormats(userData.User);
  // need to make a separate API call to get contact and address details as these details are not coming in response of user details API for petrohub, but these details are required in application. For non-petrohub user, these details are coming in response of user details API.
  // const { Contacts, Addresses } = await UserApi.getUserByUserIdPetroHub(userData.User.UserID);

  // const { Contacts = dummyResponseDataForPetroHubUser.Contacts } = dummyResponseDataForPetroHubUser; // for petrohub, as contacts are not coming in response, using dummy contacts data for now. Will remove it once we get contacts data from API response.
  // const { Addresses = dummyResponseDataForPetroHubUser.Addresses } = dummyResponseDataForPetroHubUser; // for petrohub, as addresses are not coming in response, using dummy addresses data for now. Will remove it once we get addresses data from API response.
  const userGlobalFilterPetroHub = window.localStorage.getItem('userGlobalFilterPetroHub');
  // console.log('Contacts', Contacts);
  // console.log('Addresses', Addresses);

  dispatch(
    authActions.startImpersonating({
      UserAccountID,
      UserID,
      Username,
      dateFormat,
      dateTimeFormat,
      user: userData.User,
      roleClaims: userData.RoleClaims,
      userObjects: userData.UserObjects,
      permissions: userData.Permissions,
      userToRoles: userData.UserToRoles,
      // userContactList: Contacts,
      // userAddressList: Addresses,
      isPetroHubUser: true,
      userGlobalFilterPetroHub: userGlobalFilterPetroHub ? JSON.parse(userGlobalFilterPetroHub) : null,
    })
  );
};
